import React, { useState, useEffect } from 'react'
import styles from './index.module.css'
import Loading from '../../../common/components/Loading'

const PrivacyContent = () => {
  const [content, setContent] = useState('')
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    fetch('/privacy-policy.txt')
      .then(res => res.text())
      .then((text) => {
        const html = text
          .replace(/className=\{styles\.placeholder\}/g, `class="${styles.placeholder}"`)
          .replace(/className=\{styles\.bulletList\}/g, `class="${styles.bulletList}"`)
          .replace(/className=\{styles\.subtitle\}/g, `class="${styles.subtitle}"`)
          .replace(/style=\{\{\s*textTransform:\s*'uppercase'\s*\}\}/g, 'style="text-transform: uppercase"')
        setContent(html)
      })
      .catch(err => console.error('Failed to load privacy policy', err))
      .finally(() => {
        setLoading(false)
      })
  }, [])

  return (
    <div className={styles.content}>
      <h1 className={styles.title}>PRIVACY POLICY</h1>
      {loading ? <div className={styles.loadingWrap}>
        <Loading />
      </div> : (
      <div dangerouslySetInnerHTML={{ __html: content }} />
      )}

      
    </div>
  )
}

export default PrivacyContent
